import React, { useState, useEffect, FC } from 'react';
import KickImage from 'Reuseables/KickImage';
import FlashSaleElectric from '../../../images/fs-electric.png';
import { getCollectionList } from '../../../actions/kafairAction';
import { connect } from 'react-redux';
import ProductSlider from './Helpers/ProductSlider';
import moment from 'moment';

type FlashSaleHomepage = {
  history: History;
  category: string;
  getCollectionList: (
    args: string,
    slug: string,
    payload: Object,
    name: string,
  ) => any;
  dataFlashSale: Array<Object>;
  dataCategory: string;
};

interface History {
  push: (args: string) => any;
  replace: (args: string) => any;
}

const FlashSaleHomepage: FC<FlashSaleHomepage> = ({
  history,
  category,
  getCollectionList,
  dataFlashSale,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  useEffect(() => {
    // Payload for flash sale

    const payload = {
      availables: true,
      per_page: 11,
      page: 1,
      category,
    };

    // Get flash sale data

    getCollectionList(category, 'flash-sale', payload, 'flash_sale')
      .then(({ value }) => {
        setIsActive(value.data.active);
        setStart(value.data.starts_at);
        setEnd(value.data.expiry);
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    // Check flash sale timer
    checkPathFlashSaleHomepage();
  }, [start, end]);

  function navigate() {
    // Navigate flash sale to collection page
    return `/${category}/collection/flash-sale`;
  }

  function checkPathFlashSaleHomepage() {
    // Function to check flash sale timer whether to display flash sale collection or not
    if (moment().format() <= start) {
      setIsActive(false);
      return false;
    }
    if (moment().format() >= end) {
      setIsActive(false);
      return false;
    }
    return location.pathname === '/' ||
      location.pathname === '/sneakers' ||
      location.pathname === '/streetwear' ||
      location.pathname === '/fashion' ||
      location.pathname === '/apparel' ||
      location.pathname === '/luxury' ||
      location.pathname === '/lifestyle' ||
      location.pathname === '/toys' ||
      location.pathname === '/electronics-collectibles' ||
      location.pathname === '/madeindonesia'
      ? setIsActive(true)
      : setIsActive(false);
  }

  if (dataFlashSale.length <= 0 || !isActive) return null;

  if (window.screen.availWidth < 480) {
    return (
      <div
        style={{ padding: '0px', marginTop: '0px', marginBottom: '10px' }}
        className="KickFair-v3"
      >
        <div
          style={{ paddingLeft: '20px', paddingRight: '20px' }}
          className="KickFairV3-Header"
        >
          <div className="KickFairV3-Title">
            <p>Flash Sale</p>
          </div>
          <div className="KickFairV3__Desc">
            <div
              style={{ backgroundColor: 'rgba(254, 209, 100, 0.1)' }}
              className="tickets"
            >
              <KickImage src={FlashSaleElectric} alt="Event ticket" />
              <p style={{ fontFamily: 'Nunito-Regular' }}>
                Ends in{' '}
                <span style={{ fontFamily: 'Nunito-Bold', color: '#242424' }}>
                  04 : 37 : 15
                </span>
              </p>
            </div>
            <div className="KickFairV3-View">
              <a href={navigate()}>
                <p>View All</p>
              </a>
            </div>
          </div>
        </div>
        <div style={{ padding: '0px' }} className="KickFairV3-Main">
          <ProductSlider
            chosenOption={'Flash Sale'}
            dataProducts={dataFlashSale}
            history={history}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="KickFair-v3">
      <div className="KickFairV3-Header">
        <div className="KickFairV3-Title">
          <p>Flash Sale</p>
          <KickImage src={FlashSaleElectric} alt="Event ticket" />
          <p>Ends in </p>
        </div>
        <div className="KickFairV3-Ticket">
          <a href={navigate()}>
            <p>View All</p>
          </a>
        </div>
      </div>
      <div className="KickFairV3-Main">
        {dataFlashSale.length > 0 && (
          <ProductSlider
            chosenOption={'Flash Sale'}
            navigateUrl={`/${category}/collection/flash-sale`}
            dataProducts={dataFlashSale}
          />
        )}
      </div>
    </div>
  );
};

interface Data {
  data: Array<Object>;
}
interface FlashSale {
  flashSale: Data;
}
interface DataKaFair {
  dataKaFair: FlashSale;
}

const mapStateToProps = (state: DataKaFair) => ({
  dataFlashSale: state.dataKaFair.flashSale.data,
});

const mapDispatchToProps = (dispatch: any) => ({
  getCollectionList: (
    category: string,
    slug: string,
    payload: Object,
    name: string,
  ) => dispatch(getCollectionList(category, slug, payload, name)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FlashSaleHomepage);
